import { makeStyles, createStyles } from '@material-ui/core/styles'

export const useLayoutFooterStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      backgroundColor: '#212121',
      zIndex: 99,
      padding: '40px 70px 25px 70px',
      [theme.breakpoints.down(1920)]: {
        padding: '40px 120px 25px 120px'
      },
      [theme.breakpoints.down(1500)]: {
        padding: '40px 80px 25px 80px'
      },
      [theme.breakpoints.down(1280)]: {
        flexDirection: 'column'
      },
      [theme.breakpoints.down(960)]: {
        padding: '40px 16px 25px 16px'
      }
    },

    blockSocial: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down(1280)]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 30
      }
    },
    facebook: {
      marginRight: 20,
      [theme.breakpoints.down(1920)]: {
        marginRight: 0
      },
      '&:hover': {
        color: '#0165E1'
      }
    },
    vkontakte: {
      marginRight: 20,
      color: 'rgba(255, 255, 255, 0.6)',
      [theme.breakpoints.down(1920)]: {
        marginRight: 0
      },
      '&:hover': {
        color: '#0077FF'
      },
      '& svg, & path': {
        fill: 'currentColor'
      }
    },

    logo: {
      width: 197,
      height: 40
    },

    icons: {
      marginTop: 25,
      [theme.breakpoints.down(1280)]: {
        marginTop: 0
      }
    },

    iconsBlock: {
      display: 'flex',
      justifyContent: 'flex-start',
      [theme.breakpoints.down(1280)]: {
        justifyContent: 'space-between'
      },
      [theme.breakpoints.down(768)]: {
        marginRight: 50,
        marginBottom: 40
      }
    },

    link: {
      fontSize: 14,
      fontFamily: 'Roboto',
      color: 'rgba(255, 255, 255, 0.6)',
      '&:not(:last-child)': {
        marginRight: 20
      }
    },

    telegram: {
      marginRight: 20,
      [theme.breakpoints.down(1920)]: {
        marginRight: 0
      },
      '&:hover': {
        color: theme.palette.primary.main
      }
    },

    youtube: {
      marginRight: 20,
      [theme.breakpoints.down(1920)]: {
        marginRight: 0
      },
      '&:hover': {
        color: theme.palette.secondary.main
      }
    },

    twitter: {
      marginRight: 20,
      [theme.breakpoints.down(1920)]: {
        marginRight: 0
      },
      '&:hover': {
        color: theme.palette.primary.main
      }
    },

    linkedin: {
      marginRight: 20,
      [theme.breakpoints.down(1920)]: {
        marginRight: 0
      },
      '&:hover': {
        color: theme.palette.primary.main
      }
    },

    servicesBlock: {
      display: 'flex',
      justifyContent: 'space-between',
      [theme.breakpoints.down(1920)]: {
        flexDirection: 'column'
      },
      [theme.breakpoints.down(1280)]: {
        flexDirection: 'row'
      },
      [theme.breakpoints.down(768)]: {
        flexDirection: 'column'
      }
    },

    services: {
      display: 'flex',
      flexDirection: 'column',
      '&:not(:last-child)': {
        marginRight: 50
      },
      [theme.breakpoints.down(1920)]: {
        '&:not(:last-child)': {
          marginBottom: 30
        }
      },
      [theme.breakpoints.down(1280)]: {
        '&:not(:last-child)': {
          marginBottom: 50
        }
      },
      [theme.breakpoints.down(768)]: {
        '&:not(:last-child)': {
          marginBottom: 25
        },
        '&:last-child': {
          marginBottom: 40
        }
      }
    },

    linkService: {
      marginBottom: 20,
      fontSize: 18,
      fontWeight: 500,
      color: 'rgba(255, 255, 255, 0.6)',
      [theme.breakpoints.down(1920)]: {
        marginBottom: 10
      }
    },

    linkSubService: {
      marginBottom: 20,
      fontSize: 14,
      fontWeight: 500,
      color: 'rgba(255, 255, 255, 0.6)',
      [theme.breakpoints.down(1920)]: {
        marginBottom: 15
      }
    },

    linkSubServiceFaq: {
      fontSize: 14,
      fontWeight: 500,
      color: 'rgba(255, 255, 255, 0.6)'
    },

    linkBtn: {
      width: 'fit-content',
      padding: 0,
      fontSize: 14,
      fontWeight: 500,
      fontFamily: 'Montserrat',
      color: '#ffffff',
      background: 'inherit',
      border: 'none',
      outline: 'none',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline'
      }
    },

    documentsBlock: {
      display: 'flex',
      flexDirection: 'row',
      [theme.breakpoints.down(768)]: {
        flexDirection: 'column'
      }
    },

    documents: {
      display: 'flex',
      flexDirection: 'column',
      width: 250,
      '&:not(:last-child)': {
        marginRight: 40
      },
      [theme.breakpoints.down(1920)]: {
        width: 300,
        '&:not(:last-child)': {
          marginRight: 50
        }
      },
      [theme.breakpoints.down(1500)]: {
        width: 250
      },
      [theme.breakpoints.down(768)]: {
        width: 300,
        '&:not(:last-child)': {
          marginRight: 0
        }
      }
    },

    linkDocument: {
      fontSize: 14,
      color: 'rgba(255, 255, 255, 0.6)',
      marginBottom: 12,
      [theme.breakpoints.down(1920)]: {
        marginBottom: 20
      },
      [theme.breakpoints.down(1280)]: {
        marginBottom: 12
      },
      [theme.breakpoints.down(768)]: {
        marginBottom: 16
      }
    },

    linkPage: {
      fontSize: 18,
      fontWeight: 500,
      color: 'rgba(255, 255, 255, 0.6)',
      marginBottom: 12,
      [theme.breakpoints.down(1920)]: {
        marginBottom: 20
      },
      [theme.breakpoints.down(1280)]: {
        marginBottom: 12
      },
      [theme.breakpoints.down(768)]: {
        marginBottom: 16
      }
    },

    activeLink: {
      color: '#fff'
    }
  })
)
